/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login
 */
import Vue from 'vue';

export default {

  data() {
    return {
      user: {
        password: null,
      },
      static: {
        password: "supermanager0123",
      },
      error: null,
    };
  },
  methods: {

    loginStaticPwd(user) {
      if(user.password == this.static.password) {
        localStorage.setItem("staticPwdPassed", true);
        Vue.router.push({
          name: 'login.index',
        });
      }
      else {
        this.error = 'Wrong credentials';
      }
    },
  }

};



// WEBPACK FOOTER //
// ./src/app/pages/static-pwd/index/index.js